module.exports = __webpack_public_path__ + "media/images/icons/person2x-76a8be0b011ffea00280e416dfa89d07.png";